export const koContent = {
  introduction: {
    content: [
      "1996년 첫 등장 이후, 포켓몬 시리즈는 전 세계인의 마음을 사로잡아 세계에서 가장 사랑받는 엔터테인먼트 브랜드 중 하나가 되었습니다. 저희의 랜덤 포켓몬 생성기는 새로운 포켓몬을 발견하고 싶거나, 균형 잡힌 팀을 구성하고 싶거나, 포켓몬 여행에서 놀라움을 즐기고 싶은 모든 연령대의 트레이너를 위해 설계되었습니다.",
      "다음 대회를 위한 팀 구성에 영감을 얻고 싶은 베테랑 트레이너든, 도감을 채우고 싶은 캐주얼 팬이든, 이 포켓몬 랜덤라이저 도구를 통해 광활한 포켓몬 세계를 재미있고 상호작용적으로 탐험할 수 있습니다."
    ]
  },
  howToUse: {
    content: [
      "랜덤 포켓몬 선택기의 사용법은 간단하고 직관적입니다. 다음 단계에 따라 이상적인 포켓몬 팀을 생성해 보세요:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "포켓몬 수 선택: 생성하고 싶은 포켓몬의 수(1~8마리)를 결정합니다." },
          { type: "text", content: "타입 선택: 불꽃, 물, 전기 등 특정 타입으로 필터링하거나 \"모두\"를 선택하여 모든 타입을 포함할 수 있습니다." },
          { type: "text", content: "세대 선택: 1세대부터 8세대까지, 또는 \"모두\"를 선택하여 모든 세대의 포켓몬을 포함할 수 있습니다." },
          { type: "text", content: "희귀도 설정: 생성될 포켓몬의 희귀도를 결정합니다." },
          { type: "text", content: "\"생성\" 클릭: 설정이 완료되면 버튼을 클릭하여 조건에 맞는 포켓몬을 생성합니다." },
          { type: "text", content: "결과 확인: 각 포켓몬의 종족값, 특성, 타입 등 자세한 정보를 확인할 수 있습니다!" }
        ]
      },
      "매개변수는 언제든지 조정할 수 있으며, 여러 번 시도하여 다양한 포켓몬 조합을 발견할 수 있습니다."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "완전 무료: 랜덤 포켓몬 생성기는 100% 무료이며, 숨겨진 비용이나 구독료가 전혀 없습니다." },
          { type: "text", content: "맞춤 설정 가능: 타입, 세대, 희귀도로 필터링하여 랜덤 선택을 커스터마이즈할 수 있습니다." },
          { type: "text", content: "학습 도구: 다양한 포켓몬의 종족값, 특성, 타입에 대해 배울 수 있습니다." },
          { type: "text", content: "팀 구성: 캐주얼 배틀이나 공식 대회를 위한 균형 잡힌 팀을 빠르게 생성할 수 있습니다." },
          { type: "text", content: "도전 과제 생성: 랜덤으로 생성된 포켓몬만을 사용하는 독특한 도전을 만들 수 있습니다." },
          { type: "text", content: "계정 불필요: 가입이나 개인정보 입력 없이 바로 사용할 수 있습니다." }
        ]
      }
    ]
  },
  history: {
    content: [
      "포켓몬 시리즈는 1996년 타지리 사토시가 닌텐도 게임보이용으로 첫 포켓몬 게임을 만들면서 시작되었습니다. 타지리의 어린 시절 곤충 채집 취미에서 영감을 받아, \"포켓 몬스터\"(줄여서 포켓몬)라 불리는 생물을 잡고, 키우고, 배틀하는 컨셉이 탄생했습니다.",
      "포켓몬 역사의 주요 이정표:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996년: 일본에서 『포켓몬스터 레드·그린』 출시" },
          { type: "text", content: "1998년: 해외에서 『포켓몬스터 레드·블루』 출시" },
          { type: "text", content: "1999년: 포켓몬 트레이딩 카드 게임 전 세계 출시" },
          { type: "text", content: "2000년: 『포켓몬스터 골드·실버』 출시, 100마리의 새로운 포켓몬 추가" },
          { type: "text", content: "2016년: 『Pokémon GO』 출시, 모바일 플랫폼으로 확장" },
          { type: "text", content: "2019년: Nintendo Switch에서 『포켓몬스터 소드·실드』 출시" }
        ]
      },
      "현재는 8세대 900종 이상의 포켓몬을 보유하고 있으며, 비디오 게임, 카드 게임, 애니메이션 시리즈, 영화, 상품, 모바일 애플리케이션 등을 포함하는 역사상 가장 수익성 높은 미디어 프랜차이즈 중 하나로 성장했습니다."
    ]
  },
  popularPokemon: {
    content: [
      "포켓몬의 역사에서 몇몇 포켓몬들은 시리즈를 대표하는 상징적인 존재가 되었습니다:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "피카츄: 시리즈의 마스코트인 전기 타입 포켓몬으로, 번개 모양의 꼬리와 분홍색 볼이 특징입니다." },
          { type: "text", content: "리자몽: 팬들에게 인기가 높은 불꽃·비행 타입 포켓몬으로, 드래곤 같은 외모와 강력한 능력을 가지고 있습니다." },
          { type: "text", content: "뮤츠: 뮤의 유전자 조작으로 만들어진 전설의 에스퍼 타입 포켓몬으로, 압도적인 힘을 지니고 있습니다." },
          { type: "text", content: "이브이: 샤미드, 쥬피썬더, 부스터 등 다양한 타입으로 진화할 수 있는 특별한 능력을 가진 인기 포켓몬입니다." },
          { type: "text", content: "갸라도스: 약한 잉어킹에서 진화하는 강력한 물·비행 타입 포켓몬입니다." },
          { type: "text", content: "루카리오: 파동의 힘을 가지고 있으며, 대전에서도 인기가 높은 격투·강철 타입 포켓몬입니다." },
          { type: "text", content: "개굴닌자: 애니메이션 시리즈에서 인기를 얻은 물·악 타입의 닌자 포켓몬입니다." }
        ]
      },
      "저희의 랜덤 포켓몬 생성기를 통해 이러한 상징적인 포켓몬들과 다른 매력적인 종류의 포켓몬들을 발견할 수 있습니다."
    ]
  },
  popularGames: {
    content: [
      "포켓몬 게임 시리즈는 다양한 플랫폼에서 수많은 인기작을 만들어냈습니다:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "『포켓몬스터 레드·블루·옐로』: 게임보이에서 현상을 일으킨 원조 게임입니다." },
          { type: "text", content: "『포켓몬스터 골드·실버·크리스탈』: 성도지방과 시간 시스템을 도입했습니다." },
          { type: "text", content: "『포켓몬스터 루비·사파이어·에메랄드』: 호연지방과 더블배틀로 세계를 확장했습니다." },
          { type: "text", content: "『포켓몬스터 다이아몬드·펄·플래티넘』: 닌텐도 DS에서 온라인 기능을 구현했습니다." },
          { type: "text", content: "『포켓몬스터 블랙·화이트』: 새로운 포켓몬만으로 구성되고 스토리를 중시한 접근방식을 취했습니다." },
          { type: "text", content: "『포켓몬스터 X·Y』: 3D 모델과 메가진화를 도입했습니다." },
          { type: "text", content: "『포켓몬스터 썬·문』: 체육관 배틀 대신 섬 도전을 도입했습니다." },
          { type: "text", content: "『Pokémon GO』: 세계적인 현상이 된 증강현실 모바일 게임입니다." },
          { type: "text", content: "『포켓몬스터 소드·실드』: 와일드 에리어를 도입한 Nintendo Switch 작품입니다." },
          { type: "text", content: "『Pokémon LEGENDS 아르세우스』: 시리즈 최초의 오픈월드 형식 작품입니다." }
        ]
      },
      "각 작품은 새로운 메카닉과 포켓몬을 도입하여, 저희의 랜덤 포켓몬 생성기로 탐험할 수 있는 포켓몬 세계를 계속 확장하고 있습니다."
    ]
  },
  tradingContests: {
    content: [
      "포켓몬 교환은 시리즈의 근간을 이루는 요소 중 하나입니다. 최초의 게임이 페어로 출시된 것도 플레이어들이 서로 교환하여 도감을 완성하도록 장려하기 위해서였습니다. 이 사회적 요소가 포켓몬의 인기를 넓혔고, 오늘날에도 중요한 역할을 하고 있습니다.",
      "교환의 주요 특징:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "버전 한정 포켓몬은 교환으로만 얻을 수 있습니다" },
          { type: "text", content: "괴력몬이나 유령몬과 같이 교환을 통해 진화하는 포켓몬이 있습니다" },
          { type: "text", content: "현대 게임에서는 글로벌 트레이드 시스템(GTS)으로 전 세계와 교환이 가능합니다" },
          { type: "text", content: "레어 포켓몬이나 색이 다른 포켓몬은 스테이터스 심볼로서 교환됩니다" }
        ]
      },
      "3세대에서 도입된 포켓몬 콘테스트는 배틀 외의 경쟁 방식을 제공하여, 포켓몬의 외모, 퍼포먼스, 어필로 경쟁합니다. 콘테스트의 특징:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "다양한 콘테스트 부문(근사함, 아름다움, 귀여움, 슬기로움, 강인함)" },
          { type: "text", content: "콘테스트 전용 기술" },
          { type: "text", content: "나무열매와 포핀으로 포켓몬의 컨디션 관리" },
          { type: "text", content: "예비심사와 퍼포먼스 라운드를 포함한 다단계 경기" }
        ]
      },
      "저희의 랜덤 포켓몬 생성기를 통해 콘테스트에서 활약할 수 있는 포켓몬이나 가치 있는 교환 파트너가 될 수 있는 포켓몬을 찾을 수 있어, 포켓몬 체험에 더 큰 확장성을 제공합니다."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "이 랜덤 포켓몬 생성기는 무료인가요?",
            answer: "네, 완전히 무료이며, 숨겨진 비용이나 구독료가 전혀 없습니다."
          },
          {
            type: "faq",
            question: "포켓몬 데이터는 얼마나 정확한가요?",
            answer: "모든 데이터는 공식 PokéAPI에서 가져오며, 정확성과 최신성이 보장됩니다."
          },
          {
            type: "faq",
            question: "특정 세대의 포켓몬만 생성할 수 있나요?",
            answer: "네, 1세대부터 8세대까지 선택할 수 있으며, \"모두\"를 선택하여 모든 세대를 포함할 수도 있습니다."
          },
          {
            type: "faq",
            question: "희귀도 필터는 어떻게 작동하나요?",
            answer: "전설/신화 포켓몬 여부, 기초 경험치 등의 요인을 기반으로 각 포켓몬에 1-10의 희귀도 값을 할당합니다."
          },
          {
            type: "faq",
            question: "생성된 포켓몬을 저장하거나 내보낼 수 있나요?",
            answer: "현재는 스크린샷으로 결과를 저장할 수 있습니다. 향후 업데이트에서 저장/내보내기 기능 추가를 검토 중입니다."
          },
          {
            type: "faq",
            question: "랜덤 포켓몬 생성기는 모바일에서도 사용할 수 있나요?",
            answer: "네, 스마트폰, 태블릿, 데스크톱 컴퓨터에서 완벽하게 지원됩니다."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "저희의 랜덤 포켓몬 생성기는 캐주얼 팬과 열정적인 트레이너 모두에게 무한한 가능성을 제공합니다. 새로운 즐겨찾기를 발견하든, 테마 팀을 만들든, 예상치 못한 조합으로 자신에게 도전하든, 저희 도구는 광활한 포켓몬 세계를 탐험할 수 있는 재미있고 교육적인 방법을 제공합니다.",
      "저희는 항상 생성기를 새로운 기능과 옵션으로 개선하기 위해 노력하고 있습니다. 오늘 바로 환경 설정을 지정하고 '생성'을 클릭하여 어떤 포켓몬이 당신을 기다리고 있는지 확인해 보세요!",
      "친구들 및 다른 트레이너들과 결과를 공유하고, 포켓몬 여행에서 랜덤 포켓몬 생성기를 어떻게 사용하고 있는지 알려주세요. 즐거운 발견 되세요!"
    ]
  },
  // "내가 어떤 포켓몬인가?" 콘텐츠 섹션
  whichPokemonIntro: {
    content: [
      "당신이 어떤 포켓몬과 가장 비슷한지 궁금한 적이 있으신가요? 저희의 '내가 어떤 포켓몬인가?' 도구는 당신의 신체적 특징을 기반으로 포켓몬 분신을 발견할 수 있는 재미있고 독특한 방법을 제공합니다.",
      "이 혁신적인 기능은 당신의 키와, 체중을 분석하여 당신의 체형에 가장 가까운 포켓몬을 식별합니다. 당신이 리자몽처럼 크든 피카츄처럼 작든, 저희 알고리즘은 놀라운 정확도로 당신에게 완벽하게 맞는 포켓몬을 찾아냅니다."
    ]
  },
  whichPokemonHowToUse: {
    content: [
      "저희의 '내가 어떤 포켓몬인가?' 도구를 사용하는 것은 간단하며 몇 초밖에 걸리지 않습니다. 다음의 간단한 단계에 따라 당신의 포켓몬 매치를 발견하세요:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "제공된 양식에 이름(또는 별명)을 입력하세요." },
          { type: "text", content: "센티미터(cm)로 키를 입력하세요." },
          { type: "text", content: "킬로그램(kg)으로 체중을 입력하세요." },
          { type: "text", content: "'내 포켓몬 찾기' 버튼을 클릭하여 결과를 확인하세요." },
          { type: "text", content: "이름, 타입, 크기, 무게, 유사도 점수 등을 포함한 매칭된 포켓몬을 확인하세요." },
          { type: "text", content: "소셜 미디어에서 결과를 공유하거나 이미지로 다운로드하여 친구들에게 보여주세요!" }
        ]
      },
      "유사도 점수는 당신의 체형이 포켓몬의 체형과 얼마나 가까운지를 나타냅니다. 퍼센트가 높을수록 매치가 더 가깝다는 의미입니다!"
    ]
  },
  whichPokemonBenefits: {
    content: [
      "포켓몬 분신을 발견하는 것은 단순한 엔터테인먼트 이상의 가치를 제공합니다:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "재미있는 학습 방법: 당신의 신체적 특징과 일치하는 새로운 포켓몬을 발견하고 배우세요." },
          { type: "text", content: "독특한 관점: 포켓몬 세계의 렌즈를 통해 자신을 보세요." },
          { type: "text", content: "대화 시작제: 친구들과 결과를 공유하고 각자에게 어떤 포켓몬이 맞는지 비교하세요." },
          { type: "text", content: "코스프레 영감: 코스프레 아이디어를 위해 자연스럽게 당신의 체형에 맞는 포켓몬을 찾으세요." },
          { type: "text", content: "팀 구성: 포켓몬 게임에서 당신과 친구들의 신체적 유사성에 기반한 테마 팀을 만드세요." }
        ]
      }
    ]
  },
  whichPokemonFAQ: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "매칭 알고리즘은 얼마나 정확한가요?",
            answer: "저희 알고리즘은 PokéAPI의 공식 포켓몬 크기 및 무게 데이터를 사용하며, 비례적 유클리드 거리를 기반으로 유사성을 계산합니다. 과학적 정확성보다는 재미를 위해 설계되었지만, 많은 사용자들이 매칭이 놀라울 정도로 적절하다고 생각합니다!"
          },
          {
            type: "faq",
            question: "왜 도구는 다른 신체적 특징을 고려하지 않나요?",
            answer: "현재는 단순함을 위해, 그리고 모든 포켓몬 종에서 가장 일관되게 문서화된 물리적 속성이기 때문에 크기와 무게에 초점을 맞추고 있습니다. 향후 업데이트에서는 더 많은 속성을 추가할 수 있습니다."
          },
          {
            type: "faq",
            question: "어떤 포켓몬과든 매칭될 수 있나요?",
            answer: "현재, 성능을 최적화하기 위해 도구는 원래의 151마리 포켓몬(1세대)과 매칭합니다. 향후 업데이트에서는 모든 세대를 포함하도록 확장할 계획입니다."
          },
          {
            type: "faq",
            question: "제 개인 데이터가 저장되거나 공유되나요?",
            answer: "아니요, 저희는 귀하가 입력하는 키, 체중, 또는 기타 개인 정보를 저장하지 않습니다. 모든 계산은 브라우저에서 이루어지며, 서버로 아무것도 전송되지 않습니다."
          },
          {
            type: "faq",
            question: "비슷한 측정값을 가진 친구와 왜 다른 포켓몬이 매칭되나요?",
            answer: "키와 체중 비율의 작은 차이가 다른 매칭으로 이어질 수 있습니다. 알고리즘은 절대값이 아닌 비율을 고려합니다."
          },
          {
            type: "faq",
            question: "소셜 미디어에서 결과를 공유할 수 있나요?",
            answer: "네! 결과를 이미지로 다운로드하거나 제공된 버튼을 사용하여 Facebook이나 Twitter 같은 플랫폼에 직접 공유할 수 있습니다."
          }
        ]
      }
    ]
  },
  whichPokemonConclusion: {
    content: [
      "저희의 '내가 어떤 포켓몬인가?' 도구는 놀라운 포켓몬 세계에서 당신이 어떻게 존재할 수 있는지에 대한 재미있는 통찰력을 제공합니다. 주로 엔터테인먼트를 위한 것이지만, 많은 사용자들이 단순한 신체적 유사성을 넘어 매칭된 포켓몬의 성격이나 능력과의 놀라운 연결점을 발견합니다.",
      "입력을 약간 변경하여 다른 키와 체중이 당신의 매칭에 어떤 영향을 미치는지 확인하거나, 친구와 가족에게 그들의 포켓몬 분신을 찾도록 도전해 보세요. 결과적인 포켓몬 페어링에 놀랄 수 있습니다!",
      "당신이 장엄한 전설의 포켓몬, 강력한 스타터, 또는 과소평가된 포켓몬스터와 매칭되든, 당신의 포켓몬 분신과 공유하는 독특한 특성을 받아들이세요. 결국, 포켓몬의 세계에서는 모든 종이 자신만의 특별한 강점과 의미를 가지고 있습니다."
    ]
  }
}; 